import { makeAutoObservable, runInAction } from "mobx";
import ApiClient from "../ApiClient";
import { UserHelpRequests } from "../types/summaryStateStypes";
export default class SummaryState {
  todayRequestsCount: number = 0;
  previousRequestsCount: number = 0;
  autoClosedRequestsCount: number = 0;
  venueClosingTime: number | null = null;
  devicesCount?: number = undefined;
  loggedInDevicesCount: number = 0;
  searchCaseResults: UserHelpRequests[] = [];
  caseSearchTerm = "";
  dataLoaded = false;
  todaysRequests: any[] = [];
  previousDayRequests: any[] = [];
  last28DaysRequests: any[] = [];
  homeDataPollingError: boolean = false;
  isHomeSummaryLoading: boolean = false;
  private pollingTimerHomeStatus: NodeJS.Timeout | undefined;

  constructor() {
    makeAutoObservable(this);
  }

  clearHomeDataPollingError() {
    this.homeDataPollingError = false;
  }

  resetCaseSearch() {
    this.caseSearchTerm = "";
    this.searchCaseResults = [];
  }

  changeVenue = () => {
    this.stopHomeDataPolling();
    this.dataLoaded = false;
    this.venueClosingTime = null;

    this.devicesCount = undefined;
    this.loggedInDevicesCount = 0;

    this.searchCaseResults = [];
    this.caseSearchTerm = "";

    this.refreshHomeData();
  };

  startHomeDataPolling = () => {
    // Clear any existing timer
    if (this.pollingTimerHomeStatus) {
      clearInterval(this.pollingTimerHomeStatus);
    }

    this.pollingTimerHomeStatus = setInterval(() => {
      this.refreshHomeData();
    }, 60000); // 60-second interval

    // Initial fetch when starting polling
    this.refreshHomeData();
  };

  stopHomeDataPolling = () => {
    this.homeDataPollingError = false;
    if (this.pollingTimerHomeStatus) {
      clearInterval(this.pollingTimerHomeStatus);
      this.pollingTimerHomeStatus = undefined;
    }
  };

  refreshHomeData() {
    // Prevent new requests if one is already pending
    if (this.isHomeSummaryLoading) {
      return;
    }

    this.isHomeSummaryLoading = true; // Set loading flag

    ApiClient.getHomeSummary()
      .then(
        (response: {
          status: number;
          data: {
            success: boolean;
            autoClosedRequestsCount: number;
            previousRequestsCount: number;
            todayRequestsCount: number;

            venueClosingTime: number;
          };
        }) => {
          runInAction(() => {
            if (response?.status !== 200 || !response?.data?.success) {
              this.homeDataPollingError = true;
              return;
            }
            // Clear any existing error on successful response
            this.homeDataPollingError = false;
            this.venueClosingTime = response?.data?.venueClosingTime;
            this.todayRequestsCount = response?.data?.todayRequestsCount;
            this.previousRequestsCount = response?.data?.previousRequestsCount;
            this.autoClosedRequestsCount =
              response?.data?.autoClosedRequestsCount;
          });
        }
      )
      .catch((error) => {
        runInAction(() => {
          this.homeDataPollingError = true;
          console.error("Error fetching home summary:", error);
        });
      })
      .finally(() => {
        runInAction(() => {
          this.dataLoaded = true;
          this.isHomeSummaryLoading = false;
        });
      });
  }
}

export const summaryState = new SummaryState();
